import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtVerify, SignJWT } from 'jose';

import item_001 from '../../images/items/item_001.png';
import item_002 from '../../images/items/item_002.png';
import item_003 from '../../images/items/item_003.png';
import item_004 from '../../images/items/item_004.png';
import item_005 from '../../images/items/item_005.png';
import item_006 from '../../images/items/item_006.png';
import item_007 from '../../images/items/item_007.png';
import item_008 from '../../images/items/item_008.png';
import item_009 from '../../images/items/item_009.png';
import item_010 from '../../images/items/item_010.png';
import item_011 from '../../images/items/item_011.png';


const TopupEventPage = () => {
  const [formData, setFormData] = useState({
    month: "",
    amount: "",
    currency: "THB",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [flow, setFlow] = useState(null);
  const [lineUserID, setLineUserID] = useState(null);
  const [refCode, setRefCode] = useState(null);
  const [otp, setOtp] = useState(null);
  const [action, setAction] = useState(null);
  const [gameid, setGameid] = useState(null);

  const [totalTopupAmount, setTotalTopupAmount] = useState(0);

  const currencyList = [
    { value: "THB", label: "ประเทศไทย บาท" },
    { value: "USD", label: "United States Dollar" },
  ];

  const monthList = [
    { value: "05/2025", label: "พฤษภาคม 2025" },
    { value: "06/2025", label: "มิถุนายน 2025" },
    { value: "07/2025", label: "กรกฎาคม 2025" },
    { value: "08/2025", label: "สิงหาคม 2025" },
    { value: "09/2025", label: "กันยายน 2025" },
    { value: "10/2025", label: "ตุลาคม 2025" },
    { value: "11/2025", label: "พฤศจิกายน 2025" },
    { value: "12/2025", label: "ธันวาคม 2025" },
    { value: "01/2026", label: "มกราคม 2026" },
    { value: "02/2026", label: "กุมภาพันธ์ 2026" },
    { value: "03/2026", label: "มีนาคม 2026" },
  ];

  const topupAmountList = [
    { value: "500", label: "สะสมครบ 500 บาท" },
    { value: "1000", label: "สะสมครบ 1,000 บาท" },
    { value: "1500", label: "สะสมครบ 1,500 บาท" },
    { value: "3000", label: "สะสมครบ 3,000 บาท" },
    { value: "5000", label: "สะสมครบ 5,000 บาท" },
    { value: "10000", label: "สะสมครบ 10,000 บาท" },
    { value: "12000", label: "สะสมครบ 12,000 บาท" },
  ];

  const topupAmountListUSD = [
    { value: "17", label: "สะสมครบ 17 USD" },
    { value: "40", label: "สะสมครบ 40 USD" },
    { value: "50", label: "สะสมครบ 50 USD" },
    { value: "100", label: "สะสมครบ 100 USD" },
    { value: "170", label: "สะสมครบ 170 USD" },
    { value: "340", label: "สะสมครบ 340 USD" },
    { value: "400", label: "สะสมครบ 400 USD" },
  ];

  const rewardItems = {
    THB: {
      "500": [
        { icon: item_009, description: "บัตรปรับเรท 5 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 5 ใบ" },
        { icon: item_005, description: "ปีกแฟชั่น Half Wing ระยะเวลา 7 วัน 1 ชิ้น" },
      ],
      "1000": [
        { icon: item_009, description: "บัตรปรับเรท 10 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 10 ใบ" },
        { icon: item_004, description: "ปีกแฟชั่นมังกรน้ำ ระยะเวลา 30 วัน 1 ชิ้น" },
      ],
      "1500": [
        { icon: item_009, description: "บัตรปรับเรท 10 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 10 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 10 ใบ" },
        { icon: item_003, description: "ปีกแฟชั่นมังกรไฟ ระยะเวลา 30 วัน 1 ชิ้น" },
      ],
      "3000": [
        { icon: item_009, description: "บัตรปรับเรท 20 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 20 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 20 ใบ" },
        { icon: item_007, description: "บัตรล็อค 3 เรท 10 ใบ" },
      ],
      "5000": [
        { icon: item_009, description: "บัตรปรับเรท 30 ใบ" },
        { icon: item_001, description: "บัตรปรับเรทพิเศษ 30 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 30 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 30 ใบ" },
        { icon: item_007, description: "บัตรล็อค 3 เรท 30 ใบ" },
        { icon: item_002, description: "ปีกแฟชั่นทองคำ ระยะเวลา 1 ปี 1 ชิ้น" },
      ],
      "10000": [
        { icon: item_011, description: "คูปอง VIP ระดับ Gold ระยะเวลา 1 เดือน 1 ใบ" },
      ],
      "12000": [
        { icon: item_010, description: "คูปอง VIP ระดับ Platinum ระยะเวลา 1 เดือน 1 ใบ" },
      ],
    },
    USD: {
      "17": [
        { icon: item_009, description: "บัตรปรับเรท 5 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 5 ใบ" },
        { icon: item_005, description: "ปีกแฟชั่น Half Wing ระยะเวลา 7 วัน 1 ชิ้น" },
      ],
      "40": [
        { icon: item_009, description: "บัตรปรับเรท 10 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 10 ใบ" },
        { icon: item_004, description: "ปีกแฟชั่นมังกรน้ำ ระยะเวลา 30 วัน 1 ชิ้น" },
      ],
      "50": [
        { icon: item_009, description: "บัตรปรับเรท 10 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 10 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 10 ใบ" },
        { icon: item_003, description: "ปีกแฟชั่นมังกรไฟ ระยะเวลา 30 วัน 1 ชิ้น" },
      ],
      "100": [
        { icon: item_009, description: "บัตรปรับเรท 20 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 20 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 20 ใบ" },
        { icon: item_007, description: "บัตรล็อค 3 เรท 10 ใบ" },
      ],
      "170": [
        { icon: item_009, description: "บัตรปรับเรท 30 ใบ" },
        { icon: item_001, description: "บัตรปรับเรทพิเศษ 30 ใบ" },
        { icon: item_006, description: "บัตรล็อค 1 เรท 30 ใบ" },
        { icon: item_008, description: "บัตรล็อค 2 เรท 30 ใบ" },
        { icon: item_007, description: "บัตรล็อค 3 เรท 30 ใบ" },
        { icon: item_002, description: "ปีกแฟชั่นทองคำ ระยะเวลา 1 ปี 1 ชิ้น" },
      ],
      "340": [
        { icon: item_011, description: "คูปอง VIP ระดับ Gold ระยะเวลา 1 เดือน 1 ใบ" },
      ],
      "400": [
        { icon: item_010, description: "คูปอง VIP ระดับ Platinum ระยะเวลา 1 เดือน 1 ใบ" },
      ],
    }
  };

  // Decode token and set state
  useEffect(() => {
    const decodeToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      //console.log("Token:", token);

      if (token) {
        try {
          const key = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");
          const { payload } = await jwtVerify(token, key);

          // Set your state values here
          setFlow(payload.flow);
          setLineUserID(payload.lineUserID);
          setRefCode(payload.refCode);
          setOtp(payload.otp);
          setAction(payload.action);
          setGameid(payload.gameid);

        } catch (error) {
          console.error("Invalid token:", error);
          setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
        }
      } else {
        setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
      }
    };

    decodeToken(); // Call the async function
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    handleTotalAmountInqury(); // Call the async function
  }, [formData.month]); // Empty dependency array ensures this runs only once

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "currency") {
      setFormData((prev) => ({
        ...prev,
        currency: value,
        month: "",
        amount: ""
      }));
      setErrors({});
      setTotalTopupAmount(0);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.month) newErrors.month = "กรุณาเลือกกิจกรรมประจำเดือน";
    if (!formData.amount) newErrors.amount = "กรุณาเลือกยอดเติมสะสม";
    if (isAmountExceeding || totalTopupAmount <= 0) newErrors.totalTopupAmount = "ยอดเติมสะสมของคุณไม่เพียงพอ";
    if (!formData.currency) newErrors.currency = "กรุณาเลือกสกุลเงิน";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTotalAmountInqury = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (!formData.currency || !formData.month || !token) return;

    try {
      setLoading(true);
      const headers = {
        "Accept-Language": "th",
        "Accept": "application/json;charset=UTF-8",
        "Content-Type": "application/json;charset=UTF-8",
        "api-key": "ss3+Nn9s%!$$DJ35bXISQYC!c+^P4x3Rk*2nWB3Q%$k29yUzLAthISeXa%d2LMvG",
        "login-access-token": token,
      };
      const secret = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");  
      const alg = 'HS256'
      const jwt = await new SignJWT({ ...formData })
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setExpirationTime('2h')
        .sign(secret);
      const response = await axios.post(
        "https://apis.ranworld-adventures.com/v2/account/topup/redeem/monthly",
        { token: jwt }, // Body
        { headers }
      );
      setTotalTopupAmount(response.data?.data?.total);
    } catch (error) {
      setErrors({
        apiError: error.response?.data || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    if (!validateForm()) return;

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (!formData.currency || !formData.month || !formData.amount || !token) return;

    const selectedAmount = formData.amount;
    const currency = formData.currency;
    const list = currency === "THB" ? topupAmountList : topupAmountListUSD;
    const amountIndex = list.findIndex(item => item.value === selectedAmount) + 1; // +1 to match your tier levels

    try {
      setLoading(true);
      const headers = {
        "Accept-Language": "th",
        "Accept": "application/json;charset=UTF-8",
        "Content-Type": "application/json;charset=UTF-8",
        "api-key": "ss3+Nn9s%!$$DJ35bXISQYC!c+^P4x3Rk*2nWB3Q%$k29yUzLAthISeXa%d2LMvG",
        "login-access-token": token,
      };
      const secret = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");  
      const alg = 'HS256'
      const jwt = await new SignJWT({ ...formData, amountIndex })
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setExpirationTime('2h')
        .sign(secret);
      const response = await axios.post(
        "https://apis.ranworld-adventures.com/v2/account/topup/redeem/monthly/complete",
        { token: jwt }, //Body
        { headers }
      );
      setSuccessMessage(response?.data);
      setFormData({
        month: "",
        amount: "",
        currency: "THB",
      });
      setTotalTopupAmount(0);
      setErrors({});
    } catch (error) {
      setErrors({
        apiError: error.response?.data || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const ErrorModalNew = ({ title, message, onClose }) => {
    return (
      <div className="modal-overlay">
        <div className="modal2">
          <h3>{title}</h3>
          <p>{message}</p>
          <button onClick={onClose}>ปิด</button>
        </div>
      </div>
    );
  };

  const amount = formData.amount !== "" ? Number(formData.amount) : NaN;
  const topupTotal = Number(totalTopupAmount);
  const isAmountExceeding =
    formData.amount !== "" &&                    // Must not be empty
    Number.isFinite(amount) &&
    Number.isFinite(topupTotal) &&
    amount > topupTotal &&
    topupTotal > 0;

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "auto" }}>
      {/* <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img 
          src="https://thenewadventuresimages.s3.us-east-1.amazonaws.com/Add+a+heading+(5).png" 
          alt="True Money Logo" 
          style={{ maxWidth: "auto", height: "90px" }} 
        />
      </div> */}

      {errors.apiError && (
        <ErrorModalNew title="ขออภัย" message={errors.apiError} onClose={() => setErrors({ apiError : null})}/>
      )}

      {successMessage && (
        <div
          style={{
            color: "green",
            marginBottom: "20px",
            padding: "10px",
            border: "1px solid green",
            borderRadius: "5px",
            backgroundColor: "#dfd",
            fontFamily: "Prompt"
          }}
        >
          {successMessage}
        </div>
      )}

      {/* Display Query Parameters */}
      <div
        style={{
          marginBottom: "20px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
          {[
            { title: "ไอดีเกม", value: gameid },
            { title: "รหัสอ้างอิง", value: refCode },
          ].map(({ title, value }) => (
            <li
              key={title}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "5px 0",
              }}
            >
              <span style={{ fontSize: "14px", color: "#555", flex: 1 }}>{title}:</span>
              <span style={{ fontSize: "14px", color: "#555", flex: 1, textAlign: "right" }}>{value || "N/A"}</span>
            </li>
          ))}
        </ul>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Currency */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            สกุลเงิน:
            <select
              name="currency"
              value={formData.currency}
              onChange={handleInputChange}
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxSizing: "border-box",
                fontFamily: "Prompt"
              }}
            >
              {currencyList.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            {errors.currency && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors.currency}
              </span>
            )}
          </label>
        </div>

        {/* Monthly Event */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            กิจกรรมประจำเดือน:
            <select
              name="month"
              value={formData.month}
              onChange={handleInputChange}
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxSizing: "border-box",
                fontFamily: "Prompt"
              }}
            >
              <option value="">เลือกเดือนที่ต้องการรับรางวัล</option>
              {monthList.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            {errors.month && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors.month}
              </span>
            )}
          </label>
        </div>

        {/* Monthly Total */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            ยอดเติมสะสมของคุณ:
            <input
              type="text"
              name="totalAmount"
              value={Number(totalTopupAmount).toLocaleString()}
              disabled
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxSizing: "border-box",
                fontFamily: "Prompt"
              }}
            />
          </label>
          {errors.totalTopupAmount && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.totalTopupAmount}
            </span>
          )}
        </div>

        {/* Amount */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            เลือกรับรางวัล:
            <select
              name="amount"
              value={formData.amount}
              onChange={handleInputChange}
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxSizing: "border-box",
                fontFamily: "Prompt"
              }}
            >
              <option value="">เลือกยอดเติมที่ต้องการรับรางวัล</option>
              {formData.currency === "THB" && topupAmountList.length > 0 && (
                topupAmountList.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))
              )}

              {formData.currency === "USD" && topupAmountListUSD.length > 0 && (
                topupAmountListUSD.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))
              )}
            </select>
            {errors.amount && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors.amount}
              </span>
            )}
          </label>
        </div>

        {formData.amount && rewardItems[formData.currency]?.[formData.amount] && (
          <div
            style={{
              marginTop: "25px",
              marginBottom: "25px",
              borderTop: "1px solid #ccc",
              fontFamily: "Prompt"
            }}
          >
            <h4 style={{ marginBottom: "10px" }}>ของรางวัลที่คุณจะได้รับ</h4>
            <div style={{
              display: "grid",
              gridTemplateColumns: "50px auto",
              rowGap: "10px",
              columnGap: "15px"
            }}>
              {rewardItems[formData.currency][formData.amount].map((item, index) => (
                <React.Fragment key={index}>
                  <img id={item.description} src={item.icon} alt={item.description} style={{ width: "50px", height: "50px", objectFit: "contain" }} />
                  <div style={{ alignSelf: "center" }}>{item.description}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#ccc" : "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer",
            boxSizing: "border-box",
            fontFamily: "Prompt"
          }}
        >
          {loading ? "กำลังประมวณผล..." : "รับรางวัล"}
        </button>
      </form>

    </div>
  );
};

export default TopupEventPage;